<mat-expansion-panel class="nav-section" [class.mat-elevation-z0]="true"
  routerLinkActive="section-active" dense>
  <mat-expansion-panel-header>
    <mat-icon *ngIf="menu.icon">{{ menu.icon }}</mat-icon>
    <span>{{ menu.text }}</span>
  </mat-expansion-panel-header>
  <mat-nav-list dense>
    <ng-container *ngFor="let m of menu.children">
      <a *ngIf="m.show && (!m.children || m.children.length === 0)"
        mat-list-item
        [routerLink]="getRouterCommands(m)"
        routerLinkActive="active"
        [routerLinkActiveOptions]="getActiveOptions(m)"
        [disabled]="!m.enable"
        (click)="handleItemClick()">
        <mat-icon *ngIf="m.icon">{{ m.icon }}</mat-icon>
        {{ m.text }}
      </a>

      <app-sub-menu *ngIf="m.show && m.children && m.children.length > 0"
        [menu]="m"
        (onItemClick)="handleItemClick()"></app-sub-menu>
    </ng-container>
  </mat-nav-list>
</mat-expansion-panel>
